import React from "react";
import "./Login.css"
import { Modal, Button, Form, Container } from "react-bootstrap";
import { useForm } from "react-hook-form";
import axios from "../../network/api";
import { baseUrl } from "../../network/Constants";
import arrow from "../../assets/arrow.svg"

function Login({ show, handleClose, sendData }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    console.log("Login Data: ", data);

    axios
      .post(baseUrl + "/auth/login/", data)
      .then(async (response) => {
        console.log("memberLogin: " + JSON.stringify(response.data));
        localStorage.setItem("jwt", response.data.token);
        sendData(response.data.token); 
        handleClose(); 
        window.location.reload()
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Modal show={show} onHide={handleClose} centered>

        <Modal.Title >
          <div className="login-heading text-center pt-5" >Login</div>
        </Modal.Title>
      
      <Modal.Body>
        <div className="login-text text-center">
          <p>You must log in to access these features.</p>
        </div>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group controlId="formUsername">
            <div className="username d-flex justify-content-center pt-3 ">
            <Form.Control className="login-placeholder pseudo-class "
              type="text color change"
              placeholder="Username"
              {...register  ("username", { required: "Username is required"  })}
            /></div>
            {errors.username && (
              <p className="text-danger ">{errors.username.message}</p>
            )}
            
            
          </Form.Group>

          <Form.Group controlId="formPassword" className="mt-3">
         <div className="password d-flex justify-content-center  "> 
            <Form.Control className="login-placeholder pseudo-class"
            
              type="password"
              placeholder="Password"
              {...register("password", {
                required: "Password is required",
                minLength: {
                  value: 4,
                 message:   "Password must be at least 6 characters",
                },
              })}
            /></div>
            {errors.password && (
              <p className="text-danger">{errors.password.message}</p>
            )}
            
          </Form.Group>
          <div className="login-button d-flex justify-content-center pb-5">
          <Button  type="submit" variant="primary" className="  login-btn  w-50">
            Login
           <img src={arrow} className="arrow-icon "/>
          </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default Login;
